<template>
  <div class="chain-list" :class="{ isResult }">
    <div
      class="chain-item d-flex ai-center jc-between"
      v-for="(chain, index) in chainList"
      :key="index"
      @click.stop="chooseChain(index, chain.blockchain_id, chain.chain_id, chain.ns)"
    >
      <div class="left d-flex ai-center">
        <img :src="chain.icon" :class="{ isResult }" />
        <span class="text" :class="{ isResult }">{{ chain.label }}</span>
      </div>
      <img class="right" src="../assets/index/arrow-right.png" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    chainList: {
      type: Array,
    },
    isResult: {
      type: Boolean,
    },
  },
  methods: {
    chooseChain(index, blockchain_id, chain_id, ns) {
      this.$emit('chooseChain', index, blockchain_id, chain_id, ns);
    },
  },
};
</script>

<style lang="scss" scoped>
.chain-list {
  position: absolute;
  z-index: 100;
  width: 4.4rem;
  max-height: 3rem;
  overflow: auto;
  top: 0.58rem;
  left: -0.01rem;
  padding: 0.1rem;
  background: var(--chain-list-bg);
  border: 0.01rem solid var(--chain-list-border);
  border-radius: 0.12rem;
  &::-webkit-scrollbar {
    display: none;
  }
  &.isResult {
    width: 2.98rem;
    max-height: 3.64rem;
    top: 0.5rem;
  }
  .chain-item {
    padding: 0.1rem 0.15rem 0.1rem 0.1rem;
    &.isResult {
      padding: 0.1rem;
    }
    cursor: pointer;
    .left {
      img {
        width: 0.3rem;
      }
      span {
        margin-left: 0.1rem;
        font-size: 0.14rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: var(--gray-10);
      }
    }
    .right {
      width: 0.06rem;
      // height: 0.11rem;
    }
  }
  .chain-item:hover {
    background: var(--chain-list-item);
    border-radius: 0.26rem;
  }
}
@media screen and (max-width: 767px) {
  .chain-list {
    width: 100%;
    top: 1.08rem;
    max-height: 6rem;
    &.isResult {
      width: 4rem;
      max-height: 5rem;
      top: 1rem;
    }
    .chain-item {
      .left {
        img {
          width: 0.62rem;
          &.isResult {
            width: 0.48rem;
          }
        }
        span {
          margin-left: 0.2rem;
          font-size: 0.26rem;
          &.isResult {
            font-size: 0.2rem;
          }
        }
      }
      .right {
        width: 0.09rem;
      }
    }
  }
}
</style>
